import "./pt-relay-torque-switch.css"
import CLICK_CONTEXTMENU from "../../mixins/CLICK_CONTEXTMENU"
import OPEN_CLOSED from "../../mixins/OPEN_CLOSED"

export default {
  mixins: [CLICK_CONTEXTMENU, OPEN_CLOSED]
}
